import React, {useEffect, useState} from 'react';
import {fetchOrders} from "../../http/ordersAPI";
import OrderCard from "../orders/OrderCard";
import SpinnerDark from "../UI/SpinnerDark";
import {NavLink} from "react-router-dom";
import {
    normalizeOrderStatusCode,
    ORDERS_ROUTE,
    YANDEX_PVZ_ADDRESS_PREFIX,
    stripLegacyYandexPvzPrefix,
} from "../../util/Constants";
import {orderDateTimeMs} from "../../util/formatOrderDate";
import ChangePasswordForm from "./ChangePasswordForm";
import {fetchShipmentInfo, updateShipment} from "../../http/userAPI";
import ShipmentForm from "../orders/ShipmentForm";

const Profile = () => {
    const [orders, setOrders] = useState([])
    const [shipment, setShipment] = useState({
        name: '',
        address: '',
        phone: '',
        email: '',
        yandexPickupPointId: '',
    })
    const [isLoading, setIsLoading] = useState(true)
    const [shipmentErrors, setShipmentErrors] = useState('')

    const setUserShipment = () => {
        const rawAddr = shipment.address?.trim() || '';
        // ПВЗ: либо есть id пункта, либо в адресе осталась старая строка с префиксом
        const isPvz =
            Boolean(shipment.yandexPickupPointId?.trim()) || rawAddr.startsWith(YANDEX_PVZ_ADDRESS_PREFIX);
        const payload = {
            ...shipment,
            yandexPickupPointId: isPvz ? (shipment.yandexPickupPointId?.trim() || null) : null,
            address: stripLegacyYandexPvzPrefix(rawAddr) || rawAddr,
        };
        updateShipment(payload)
            .catch(err => setShipmentErrors(err.message))
    }

    useEffect(() => {
        Promise.all([
            fetchOrders({ page: 0, size: 50, sort: 'dateTime,desc' }),
            fetchShipmentInfo()
        ])
            .then(([ordersResponse, shipmentResponse]) => {
                const raw = ordersResponse.orders || []
                setOrders(
                    raw
                        .filter(
                            (order) =>
                                normalizeOrderStatusCode(order.status) !== 'CANCELED' &&
                                normalizeOrderStatusCode(order.status) !== 'DELIVERED',
                        )
                        .sort((a, b) => orderDateTimeMs(b.dateTime) - orderDateTimeMs(a.dateTime)),
                );
                const s = shipmentResponse.data || {};
                setShipment({
                    ...s,
                    address: stripLegacyYandexPvzPrefix(s.address ?? '') || (s.address ?? ''),
                });
            })
            .catch(error => setShipmentErrors(error.message))
            .finally(() => setIsLoading(false));
    }, [])


    if (isLoading) {
        return <SpinnerDark/>
    }

    return (
        <div className="space-y-8">
            <div className="grid gap-8 lg:grid-cols-2">
                <ChangePasswordForm/>
                <ShipmentForm
                    shipment={shipment}
                    setShipment={setShipment}
                    save={setUserShipment}
                    errors={shipmentErrors}
                />
            </div>

            <div className="lut-card">
                <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                    <h1 className="text-2xl font-semibold text-bark-900">
                        Активные заказы
                        <span className="ml-2 inline-flex h-7 min-w-[1.75rem] items-center justify-center rounded-full bg-pine-100 px-2 text-sm font-medium text-pine-900">
                            {orders.length}
                        </span>
                    </h1>
                    <NavLink to={ORDERS_ROUTE} className="text-sm font-medium text-pine-700 hover:underline">
                        Все заказы
                    </NavLink>
                </div>
                <div className="mt-6 flex flex-wrap gap-4">
                    {orders.length === 0 ? (
                        <p className="text-bark-500">Активных заказов нет</p>
                    ) : (
                        orders.map(order =>
                            <OrderCard
                                key={order.id}
                                id={order.id}
                                number={order.number}
                                dateTime={order.dateTime}
                                items={order.items}
                                price={order.price}
                                status={order.status}
                                shipment={order.shipmentResponse}
                                deliveryType={order.deliveryType}
                                deliveryFee={order.deliveryFee}
                            />
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

export default Profile;
